$(document).ready(function(){
	// Request SWAP : Product Issue

	if(!document.getElementById('stepProductIssue')) return false;

	// step 2 form
	var form = {
		$el: $('#stepProductIssue'),
		$submitBtn: null,
		$step2InputFile: $('#fileupload'),
		$step2InputFile2: $('#fileupload_02'),
		$step2Textarea: null,
		$step2Count: null,
		$step2Select: null,
		topic: {
			main: document.getElementById('selectTopic'),
			sub: document.getElementById('selectSubTopic'),
			sol: document.getElementById('helpfulArticles'),
			modelNum: document.querySelector('input[name="modelNum"]'),
			modal: document.getElementById('modal_help_library')
		},
		init: function(){
			this.$submitBtn = this.$el.find('.field-btn-area button');
			this.$step2Textarea = this.$el.find('.write-type textarea');
			this.$step2Count = this.$el.find('.write-type .left-text .count');
			this.$step2Select = this.$el.find('.issue-details .combobox select');
			$(this.topic.main).drawAjaxOptions({
				setTarget: this.topic.sub,
				dynamicParam: true
			});
			$(this.topic.sub).drawAjaxOptions({
				setTarget: this.topic.sol,
				dynamicParam: true,
				empty: this.empty,
				notEmpty: this.notEmpty
			});
			this.addEvent();
		},
		empty: function(){
			$(form.topic.sol).addClass('hidden');
		},
		notEmpty: function(){
			$(form.topic.sol).removeClass('hidden');
		},
		beforeSubmit: function(){
			// whole form validation;
			if(this.$el.checkValidation()) {
				this.validateFile(this.$step2InputFile);
				this.validateFile(this.$step2InputFile2);
				if(!this.$step2InputFile.closest('.field-block').hasClass('error')) {
					// form.$el.submit();
					form.$el.trigger('submit:confirmed');
				}
			}
		},
		addEvent: function(){
			this.$step2Select.on({
				'change.base': function(e){
					var param = $(form.topic.modelNum).serialize(),
						optionName = e.currentTarget.options[e.currentTarget.selectedIndex].innerHTML,
						$nameField = $(e.currentTarget).siblings().filter('input[type="hidden"]');
					form.topic.main.setAttribute('data-param', param);
					form.topic.sub.setAttribute('data-param', param+"&"+$(form.topic.main).serialize());
					$nameField.val(optionName);
				}
			});
			$(form.topic.main).on({
				'change': function(e){
					if($(form.topic.sol).length>0) {
						form.topic.sol.value='';
						form.topic.sol.setAttribute('disabled','disabled');
						$(form.topic.sol).addClass('hidden').trigger('chosen:updated');
					}
				}
			});
			$(form.topic.sol).on({
				'change': function(e){
					var modal = form.topic.modal;
					var el = e.currentTarget;
					var url = el.getAttribute('data-url');
					var param = xssfilter($(el).serialize());
					var methodType = $(el).data('ajaxMethod');

					ajax.noCacheCall(url, param, 'html', function(data){
						if(data){
							$(modal).find('.modal-body').mCustomScrollbar('destroy');
							if(!$('.navigation').hasClass('mobile-device')) {
								$(modal).find('.modal-body').html(data).mCustomScrollbar({
									theme:'dark'
								});
							} else {
								$(modal).find('.modal-body').html(data).css('overflow-y', 'auto');
							}
							$(modal).find('.modal-body').find('.modal').remove();
							$(modal).modal('show');
							initShareCommon();
							initBoardView();
							runPrint();
						}
					}, methodType);
				}
			});
			// result-selected re open popup
			$(form.topic.sol).closest('.field-block').on({
				click: function(e){
					form.topic.sol.value 
					$(form.topic.sol).trigger('popup');
				}
			}, ".result-selected");

			// Submit 버튼 click 이벤트
			this.$submitBtn.on({
				click: function(e){
					e.preventDefault();
					form.beforeSubmit();
					return false;
				}
			});

			// File upload 시 validation 체크
			this.$step2InputFile.on({
				change: function(e) {
					e.preventDefault();
					if(e.currentTarget.files[0]) {
						form.validateFile($(this));
					}
				}
			});
			this.$step2InputFile2.on({
				change: function(e) {
					e.preventDefault();
					if(e.currentTarget.files[0]) {
						form.validateFile($(this));
					}
				}
			});

			// textarea 글자수 체크
			checkTextLength(this.$step2Textarea, this.$step2Count);

			// 값이 변경되면 error 메시지 제거
			this.$step2Select.on({
				change: function(e) {
					$(this).closest('.field-block').removeClass('error');
				}
			});
			this.$step2Textarea.on('keyup, input', function(e) {
				$(this).closest('.field-block').removeClass('error');
			})
		},
		validateFile: function(obj) {
			// check file size
			var maxSize = obj.data('max'),
				extension = obj.data('extension'), // 허용되는 파일 확장자 목록, |로 구분 되어 있음 
				filesize = 0,
				browser=navigator.appName,
				file = obj.get(),
				ext,
				fileExtension,
				isOk=true,
				$fieldBlock = obj.closest('.field-block'),
				$error = $fieldBlock.find('.error-msg');

				$fieldBlock.removeClass('error');
				$error.find('>span').hide();

			if(maxSize.indexOf('MB')!=-1) {
				maxSize=parseInt(maxSize.split('MB')[0])*1024*1024;
			}
			if(obj[0].files[0]) {
				if(window.FileReader){
					fileSize = obj[0].files[0].size;
					ext = obj[0].files[0].name;
				} else {
					var fileobj = new ActiveXObject("Scripting.FileSystemObject");
					fileSize = fileobj.getFile( file.value ).size;
					ext = obj.val().split('/').pop().split('\\').pop();
				}
				// Check file size
				if(fileSize>maxSize) {
					isOk = false;
					$fieldBlock.addClass('error');
					$error.show().find('>span').hide();
					$error.find('>span.file-size-over').show();
				}

				// Check file extension
				fileExtension = ext.split('.')[ext.split('.').length-1].toLowerCase();
				// console.log(extension, fileExtension);
				if($.inArray(fileExtension, extension.split('|')) == -1) {
					isOk = false;
					$fieldBlock.addClass('error');
					$error.show().find('>span').hide();
					$error.find('>span.not-fit-type').show();
				}
			}
		}
	}

	form.init(); // whole form

});